module.exports = __webpack_public_path__ + "img/qwello-stations-iphone@2x.de4ade26.png";